import React from 'react';
import './navigation.css';
import DrawerCmb from '../Composants/drawer/drawer';
import Home from './home';
import ImportDeFichiers from './ImportDeFichiers/importDeFichiers';
import ActivationFonctionnalites from './ActivationFonctionnalites/activationFonctionnalites';
import DeploiementFonctionnalites from './DeploiementFonctionnalites/deploiementFonctionnalites';
import DonneesClient from './DonneesClient/donneesClient';
import Infrastructure from './Infrastructure/infrastructure';
import Utilisateurs from './Utilisateurs/utilisateurs';
import CopieDonnees from './CopieDonnees/copieDonnees';
import Restructuration from './Restructuration/restructuration';
import DonneesAdmin from './DonneesAdmin/donneesAdmin';
import CreationWebapp from './CreationWebapp/creationWebapp';
import Statistiques from './Statistiques/statistiques';
import ImportDeFichiers2 from './ImportDeFichiers2/importDeFichiers2';

const Navigation = ({ surDeconnexion, environnementsDisponibles }) => {
    const [view, setView] = React.useState(0);

    const renderHome = () => {
        return (
            <Home environnementsDisponibles={environnementsDisponibles}/>
        );
    }

    const renderImport = () => {
        return (
            <ImportDeFichiers2 />
        );
    }

    const renderFonctionnalites = () => {
        return (
            <ActivationFonctionnalites />
        );
    }

    const renderDeploiements = () => {
        return (
            <DeploiementFonctionnalites />
        );
    }

    const renderDonneesClient = () => {
        return (
            <DonneesClient />
        )
    }

    const renderInfrastructure = () => {
        return (
            <Infrastructure />
        )
    }

    const renderUtilisateurs = () => {
        return (
            <Utilisateurs />
        )
    }

    const renderCopie = () => {
        return (
            <CopieDonnees />
        )
    }

    const renderRestructuration = () => {
        return (
            <Restructuration />
        )
    }

    const renderDonneesAdmin = () => {
        return (
            <DonneesAdmin />
        )
    }

    const renderCreationWebapp = () => {
        return (
            <CreationWebapp />
        )
    }

    const renderStatistiques = () => {
        return (
            <Statistiques />
        )
    }

    const renderPage = () => {
        switch (view) {
            case 11: return renderDonneesAdmin();
            case 10: return renderStatistiques();
            case 9: return renderCopie();
            case 8: return renderCreationWebapp();
            case 7: return renderRestructuration();
            case 6: return renderUtilisateurs();
            case 5: return renderInfrastructure();
            case 4: return renderDonneesClient();
            case 3: return renderFonctionnalites();
            case 2: return renderDeploiements();
            case 1: return renderImport();
            case 0: //fallthrough
            default: return renderHome();
        }
    }

    return (
        <div className={`Application`}>
            <DrawerCmb handleListItemClick={setView} surDeconnexion={surDeconnexion} environnementsDisponibles={environnementsDisponibles} />
            {renderPage()}
        </div>
    );
};

export default Navigation;
